"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));
var reselect_1 = require("reselect");
var reducers_1 = require("./reducers");
var utils_1 = require("./utils");
var program_model_1 = tslib_1.__importDefault(require("./program-model"));
exports.EMPTY_OBJ = {};
var _getViews = function (state) { return get_1.default(state, reducers_1.ROOT_KEY + ".views") || exports.EMPTY_OBJ; };
var memoizedModelGetter = memoize_1.default(function (programViewId) { return reselect_1.createSelector(function (program) { return program; }, function (program) { return program_model_1.default(program); }); });
var getModelForProgram = function (program) { return memoizedModelGetter(program.programViewId)(program); };
exports.getProgramSelector = memoize_1.default(function (programViewId) { return reselect_1.createSelector(_getViews, function (views) {
    var program = get_1.default(views, programViewId + ".program");
    return program ? getModelForProgram(program) : null;
}); });
exports.getProgram = function (state, programViewId) {
    return exports.getProgramSelector(programViewId)(state);
};
function getProgramViewsLastFetched(state) {
    return get_1.default(state, reducers_1.ROOT_KEY + ".viewsLastFetched", null);
}
exports.getProgramViewsLastFetched = getProgramViewsLastFetched;
exports.getProgramViews = reselect_1.createSelector(_getViews, function (views) {
    return Object.keys(views)
        .map(function (programViewId) { return getModelForProgram(views[programViewId].program); })
        .sort(utils_1.programViewSort);
});
//# sourceMappingURL=selectors.js.map